export function buildSpaceWebUrl(
  baseUrl: string,
  spaceId: string,
  options?: {
    profileId?: string;
    surface?: "app" | "public";
  }
): string {
  const url = new URL(resolveGatewayWebOrigin(baseUrl));
  const surface = options?.surface ?? "public";
  url.pathname =
    surface === "app"
      ? `/app/spaces/${encodeURIComponent(spaceId)}`
      : `/spaces/${encodeURIComponent(spaceId)}`;
  url.search = "";
  const profileId = normalizeOptionalText(options?.profileId);
  if (surface === "app" && profileId) {
    url.searchParams.set("profileId", profileId);
  }
  url.hash = "";
  return url.toString();
}

export function resolveGatewayWebOrigin(baseUrl: string): string {
  const url = new URL(baseUrl);
  if (isLoopbackHostname(url.hostname) && url.port === "8080") {
    url.port = "3000";
  }
  if (url.hostname === "gateway.wakeloop.ai") {
    url.hostname = "wakeloop.ai";
    url.port = "";
    url.protocol = "https:";
  }
  url.pathname = "";
  url.search = "";
  url.hash = "";
  return url.origin;
}

function isLoopbackHostname(hostname: string): boolean {
  return (
    hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1"
  );
}

function normalizeOptionalText(value: unknown): string | null {
  const normalized = String(value ?? "").trim();
  return normalized.length > 0 ? normalized : null;
}
